import config from '@project/config';

const meetTheTeamBaseUrl = `${config.apiUrl}/team_members`;

export default {
  getMeetTheTeamUrl: () => meetTheTeamBaseUrl,
  singleTeamMemberUrl: (id: string) => `${meetTheTeamBaseUrl}/${id}`,
};
